import axios from "axios";
import React, { useEffect, useState } from "react";
import { Config } from "../../../../../../Config";
import SkillRecomGuide from "../../../UserGuide/Components/SkillRecomGuide";
import UserProfileGuide from "../../../UserGuide/Components/UserProfileGuide";
import DesktopAvatarMenu from "./DesktopAvatarMenu";
import SkillModal from "./SkillModal";

const HomeHead = (props) => {
  const [DesktopAvatarMenuIsOpen, setDesktopAvatarMenuIsOpen] = useState(false);
  const [IsViewAll, setIsViewAll] = useState(false);
  const [SkillModalIsOpen, setSkillModalIsOpen] = useState(false);
  const [SkillRecommendations, setSkillRecommendations] = useState();
  const [UserSkills, setUserSkills] = useState([]);
  const [UserInfo, setUserInfo] = useState();
  const [selectedRecommendation, setselectedRecommendation] = useState();

  useEffect(() => {
    fetchRecommendedSkills();
    getUserInfo();
  }, []);

  const fetchRecommendedSkills = () => {
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/skill/recommendation/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        start: 0,
        size: 20,
        criteria: {
          titleLike: "",
        },
        sorts: [
          {
            fieldName: "similarity",
            direction: "DESC",
          },
        ],
      },
    };
    axios(Req)
      .then((Res) => {
        console.log("skill recommendation response", Res);
        setSkillRecommendations(Res.data.results);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  const replaceAvatar = (Fname, Lname) => {
    return (
      <div className="span" style={{ backgroundColor: props.Colors.bg }}>
        <p style={{ color: props.Colors.text }}>
          {Fname.slice(0, 1).toUpperCase() + Lname.slice(0, 1).toUpperCase()}
        </p>
      </div>
    );
  };
  const toggleDesktopAvatarMenu = () => {
    setDesktopAvatarMenuIsOpen(!DesktopAvatarMenuIsOpen);
  };
  const toggleMenu = () => {
    if (!props.UserProfileGuideIsOpen) {
      if (window.innerWidth <= 450) {
        props.ToggleEditAvatar();
      } else {
        toggleDesktopAvatarMenu();
      }
      handleActivityState();
    }
  };
  // adds the active className to the + button under the profile
  // picture based on DesktopAvatarMenuIsOpen state
  const handleActivityState = () => {
    if (DesktopAvatarMenuIsOpen) {
      document.getElementById("avatar-menu-btn").classList.remove("is-open");
      document.getElementById("desktop-avatar-menu").classList.add("closed");
      document.getElementById("desktop-avatar-menu").classList.remove("open");
    } else {
      if (window.innerWidth > 450) {
        document.getElementById("avatar-menu-btn").classList.add("is-open");
      }
      document.getElementById("desktop-avatar-menu").classList.remove("closed");
      document.getElementById("desktop-avatar-menu").classList.add("open");
    }
  };

  const replaceSkill = (Recommendation) => {
    if (!props.SkillRecomGuideIsOpen) {
      setselectedRecommendation(Recommendation);
      setSkillModalIsOpen(true);
      setIsViewAll(false);
    }
  };

  const showAllRecommendations = () => {
    if (!props.SkillRecomGuideIsOpen) {
      setIsViewAll(true);
      setSkillModalIsOpen(true);
    }
  };

  const saveSkills = () => {
    let SelectedSkillToReplace = document.getElementById("skill-filter").value;

    let UserSkillIds = [selectedRecommendation.skill.id];
    UserSkills.map((Skill) => {
      UserSkillIds.push(Skill.id);
    });

    let RemainingSkills = [];
    UserSkillIds.map((Item) => {
      if (Item != SelectedSkillToReplace) {
        RemainingSkills.push(Item);
      }
    });

    let Data = {
      id: UserInfo.id,
      skills: RemainingSkills,
    };

    let Req = {
      method: "PUT",
      baseURL:
        window._env_.API_URL + Config.AuthBaseURL + "/api/user-info/skills",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setSkillModalIsOpen(false);
        getUserInfo();
        fetchRecommendedSkills();
        props.FetchNewJPAs();
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  const getUserInfo = () => {
    let Req = {
      method: "GET",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/user-info",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        let Skills = [];
        Res.data.skills.map((Skill) => {
          Skills.push({ name: Skill.title, id: Skill.id });
        });
        setUserSkills(Skills);
        setUserInfo(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const shortenText = (Text, Length) => {
    if (Text.length < Length) {
      return Text;
    } else {
      let Short = Text.slice(0, 12) + " ....";
      return (
        <>
          <p className="popup-text">{Text}</p>
          {Short}
        </>
      );
    }
  };

  return (
    <div className="home-head-wrapper">
      {SkillModalIsOpen && UserSkills ? (
        <SkillModal
          Close={() => setSkillModalIsOpen(false)}
          IsViewAll={IsViewAll}
          UserSkills={UserSkills}
          SkillRecommendations={SkillRecommendations}
          Save={() => saveSkills()}
          translateText={(Label) => translateText(Label)}
          PlusIcon={props.PlusCircle}
          ReplaceSkill={(Recom) => replaceSkill(Recom)}
        />
      ) : null}
      <h1 className="greetings">
        {translateText("welcome_back")}, {props.UserInfo.firstName}!
      </h1>
      <section className="home-head" id="home-head">
        {props.HeaderImage !== "" ? (
          <img className="user-header-custom" alt="" src={props.HeaderImage} />
        ) : null}
        <button
          className="edit-profile"
          onClick={() => props.ToggleEdit()}
        ></button>
        {props.SkillRecomGuideIsOpen ? <div className="overlay"></div> : null}
        {SkillRecommendations && SkillRecommendations.length > 0 ? (
          <div
            className={
              props.SkillRecomGuideIsOpen
                ? "recommended-skills skill-recoms-guide-open"
                : "recommended-skills"
            }
            style={
              props.SkillRecomGuideIsOpen && window.innerWidth > 450
                ? { zIndex: "9999" }
                : null
            }
          >
            {props.SkillRecomGuideIsOpen ? (
              <div className="shadow-box"></div>
            ) : null}
            {props.SkillRecomGuideIsOpen ? (
              <SkillRecomGuide
                ToggleNextDialog={() => props.ToggleEighthGuide()}
                TogglePreviousDialog={() => props.ToggleSixthGuide()}
                JumpToStep={(Step) => props.JumpToStep(Step)}
                CloseGuide={() => props.CloseGuide()}
                LangData={props.LangData}
                GuideHasAdditionalStep={props.GuideHasAdditionalStep}
              />
            ) : null}
            <p className="head-title"></p>
            <p className="all-link" onClick={() => showAllRecommendations()}>
              {translateText("all_recommended_skills")}
            </p>
            <section className="skills-holder">
              {SkillRecommendations ? (
                <>
                  <section className="skills-row" id="skills-row">
                    {[...SkillRecommendations]
                      .splice(0, 3)
                      .map((Recommendation) => (
                        <div className="skill-item">
                          {shortenText(Recommendation.skill.title, 14)}
                          <img
                            alt=""
                            src={props.PlusCircle}
                            onClick={() => replaceSkill(Recommendation)}
                          />
                        </div>
                      ))}
                  </section>
                </>
              ) : null}
            </section>
          </div>
        ) : null}
        <div className="avatar-holder">
          <section className="avatar-content">
            <DesktopAvatarMenu
              AvatarImage={props.UserAvatar}
              ToggleAvatarEditor={() => props.ToggleAvatarEditor()}
              LangData={props.LangData}
            />
            {props.UserAvatar.length === 0 ? (
              <React.Fragment>
                {replaceAvatar(
                  props.UserInfo.firstName,
                  props.UserInfo.lastName
                )}
              </React.Fragment>
            ) : (
              <img alt="" loading="lazy" src={props.UserAvatar} />
            )}
            {props.UserProfileGuideIsOpen ? (
              <div className="overlay"></div>
            ) : null}
            <i
              className={
                props.UserProfileGuideIsOpen
                  ? "feather-plus overlayed-on-guide"
                  : "feather-plus"
              }
              id="avatar-menu-btn"
              onClick={() => toggleMenu()}
            >
              {props.UserProfileGuideIsOpen ? (
                <UserProfileGuide
                  LangData={props.LangData}
                  ToggleNextDialog={() => props.ToggleSeventhGuide()}
                  TogglePreviousDialog={() => props.ToggleFifthGuide()}
                  JumpToStep={(Step) => props.JumpToStep(Step)}
                  CloseGuide={() => props.CloseGuide()}
                  GuideHasAdditionalStep={props.GuideHasAdditionalStep}
                />
              ) : null}
            </i>
          </section>
          <p className="user-name">
            {props.UserInfo.firstName + " " + props.UserInfo.lastName}
          </p>
          {props.UserInfo.roles.length > 0 ? (
            <p className="position">
              {props.EmployeePos ? props.EmployeePos.title : null}
            </p>
          ) : null}
        </div>
      </section>
    </div>
  );
};

export default HomeHead;
